import React, { useCallback, useState } from "react";
import GameRoomBackButton from "../GameRoomBackButton";
import { submitSoloGameResult } from "../../../services/games/gameService";
import PixelWings from "./PixelWings";
import "./PixelWingsPage.css";

export default function PixelWingsPage({ currentUser }) {
  const [saveStatus, setSaveStatus] = useState("");
  const [saveError, setSaveError] = useState("");

  const handleGameOver = useCallback(async ({ score }) => {
    if (!currentUser?.id) {
      setSaveStatus("Sign in to record scores on the Hobbli leaderboard. Your local best is still saved.");
      setSaveError("");
      return;
    }
    setSaveStatus("Saving score to Hobbli…");
    setSaveError("");
    try {
      await submitSoloGameResult({
        gameKey: "pixel-wings",
        result: "completed",
        score: Math.max(0, Math.trunc(Number(score) || 0)),
        stats: { pipes_cleared: Math.max(0, Math.trunc(Number(score) || 0)) },
      });
      setSaveStatus("Score saved! See your record in the Game Room.");
    } catch (error) {
      console.error("Pixel Wings score submission failed:", error);
      setSaveStatus("");
      setSaveError("Could not save to the Hobbli leaderboard. Your local best is safe. " + (error?.message || ""));
    }
  }, [currentUser?.id]);

  return (
    <main className="pixel-wings-page">
      <div className="pixel-wings-page__inner">
        <GameRoomBackButton standalone />
        <PixelWings onGameOver={handleGameOver} />
        {(saveStatus || saveError) && (
          <p role="status" aria-live="polite" style={{ textAlign: "center", color: saveError ? "#ffd08a" : "#a8e9ff", fontSize: "0.8rem", marginTop: "20px" }}>
            {saveError || saveStatus}
          </p>
        )}
      </div>
    </main>
  );
}
